import axios from 'axios';

// paid/free account get several basic config
export const billingConfig = () => axios.get('/billing/config');

// net new customer get several basic config
export const buyConfig = () => axios.get('/buy/config');

// edit success page get several config
export const successConfig = (params) => axios.get('/billing/success/config', {params});


